import type { AdminBasemap, MapSettings, OgcCapabilityLayer } from './types';

export const MAP_SETTINGS_STORAGE_KEY = 'ksenus_admin_map_settings_v1';

export const defaultMapSettingsTemplate: MapSettings = {
  title: '',
  code: '',
  project: '',
  crs: 'EPSG:3857 · Web Mercator',
  defaultBasemapName: 'OpenStreetMap',
  initialScaleLabel: '1:25 000',
  zoomRange: [0, 20],
  behavior: {
    rememberUserPosition: true,
    restrictPanToExtent: false,
    autoOpenLegend: false,
    persistActiveLayers: true,
    showCursorCoordinates: true,
  },
  initialView: {
    centerLat: 55.7558,
    centerLon: 37.6173,
    zoom: 12,
    minLat: 55.7058,
    minLon: 37.5373,
    maxLat: 55.8058,
    maxLon: 37.6973,
  },
  tools: {
    search: true,
    legend: true,
    share: true,
    boxSelect: true,
    measure: true,
    locate: true,
    coordinates: true,
    editFeatures: false,
    spatialQuery: true,
    clustering: true,
    objectCalculator: true,
    exportSelection: true,
    printMap: true,
    aiAnalysis: true,
    rosreestr: false,
  },
  search: {
    searchObjects: true,
    searchAddresses: false,
    minQueryLength: 3,
    maxResults: 20,
    flyToOnSelect: true,
  },
  legend: {
    groupByLayerGroup: false,
    showObjectCounts: false,
    showOpacitySlider: false,
  },
  defaultPanel: 'Слои и легенда',
};

export const seedBasemaps: AdminBasemap[] = [
  {
    id: 'basemap_osm',
    name: 'OpenStreetMap',
    sourceType: 'XYZ Tiles',
    urlTemplate: 'https://tile.openstreetmap.org/{z}/{x}/{y}.png',
    minZoom: 0,
    maxZoom: 19,
    tileSize: 256,
    crs: 'EPSG:3857',
    attribution: '© OpenStreetMap contributors',
    enabled: true,
    isDefault: true,
  },
  {
    id: 'basemap_satellite',
    name: 'Спутниковая',
    sourceType: 'XYZ Tiles',
    urlTemplate:
      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    minZoom: 0,
    maxZoom: 19,
    tileSize: 256,
    crs: 'EPSG:3857',
    attribution: 'Tiles © Esri — Source: Esri, Maxar, Earthstar Geographics',
    enabled: true,
    isDefault: false,
  },
  {
    id: 'basemap_dark',
    name: 'Тёмная подложка',
    sourceType: 'XYZ Tiles',
    urlTemplate: 'https://basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
    minZoom: 0,
    maxZoom: 20,
    tileSize: 256,
    crs: 'EPSG:3857',
    attribution: '© OpenStreetMap contributors © CARTO',
    enabled: false,
    isDefault: false,
  },
];

export const mockOgcCapabilities: OgcCapabilityLayer[] = [
  { id: 'ogc_1', group: 'Городская инфраструктура', name: 'Тепловые сети', protocol: 'WFS', geometryType: 'LineString', editable: true },
  { id: 'ogc_2', group: 'Городская инфраструктура', name: 'Тепловые камеры', protocol: 'WFS', geometryType: 'Point', editable: true },
  { id: 'ogc_3', group: 'Городская инфраструктура', name: 'Зоны теплоснабжения', protocol: 'WMS', geometryType: 'Polygon', editable: false },
  { id: 'ogc_4', group: 'Кадастровые данные', name: 'Земельные участки', protocol: 'WFS', geometryType: 'MultiPolygon', editable: true },
  { id: 'ogc_5', group: 'Кадастровые данные', name: 'Кадастровый растр', protocol: 'WMTS', geometryType: 'Tiles', editable: false },
  { id: 'ogc_6', group: 'Экология', name: 'Зоны риска', protocol: 'WMS', geometryType: 'Polygon', editable: false },
  { id: 'ogc_7', group: 'Экология', name: 'Пункты мониторинга', protocol: 'WFS', geometryType: 'Point', editable: true },
];

export function loadMapSettings(): MapSettings | null {
  try {
    const raw = localStorage.getItem(MAP_SETTINGS_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as MapSettings;
    return parsed?.initialView ? parsed : null;
  } catch {
    return null;
  }
}

export function saveMapSettings(settings: MapSettings) {
  localStorage.setItem(MAP_SETTINGS_STORAGE_KEY, JSON.stringify(settings));
}

